import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the ImagepreviewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-imagepreview',
  templateUrl: 'imagepreview.html',
})
export class ImagepreviewPage {
  idx: number;

  imagepath1: string;
  imagepath2: string;
  imagepath3: string;

  slideIndex = 1;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.idx = navParams.get('index')

    this.imagepath1 = navParams.get('image1')
    this.imagepath2 = navParams.get('image2')
    this.imagepath3 = navParams.get('image3')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ImagepreviewPage');
  }

  plusSlides(n) {
    this.slideIndex = this.slideIndex + n;
    if (this.slideIndex > 3) {
      this.slideIndex = 1;
    }
    if (this.slideIndex < 1) {
      this.slideIndex = 3;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/imagepreview/imagepreview.ts